// Copyright (c) 2022 by Move Closer

import { AnyObject } from '@movecloser/front-core'

import { Drawers } from '../config/modals'

import { IDrawer } from '../../shared/contracts/services'

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export const openVariantDrawer = (drawerConnector: IDrawer, payload?: AnyObject, config?: AnyObject) => {
  drawerConnector.open(Drawers.Variant, payload, config)
}
